import axios from 'axios';   
import {API_BASE_URL} from '../utils/constants'; 

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    var user = JSON.parse(localStorage.getItem("User"));
      var  accessToken =  "";
      if(user){
        accessToken = user.token;
      }
       //const  accessToken = "";

    // Do something before request is sent 
    config.headers= {
        "x-access-token": accessToken,
      };

    // OR config.headers.common['Authorization'] = `Bearer ${your_token}`;
    config.baseURL = API_BASE_URL;

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch
};